import Title from 'Components/Typography/Title';
import styled from 'styled-components';
import { mediaLgDown } from 'theme/helpers/css';
import { FontFamily } from 'theme';
import { colors } from 'constants/colors';

const BlockTitle = styled(Title).attrs({
  fontFamily: FontFamily.secondFont,
  color: colors.blackRussian,
})`
  font-size: 40px;
  line-height: 48px;

  ${mediaLgDown`
    font-size: 26px;
    line-height: 34px;
  `}
`;

export default BlockTitle;
